import JSZip from "jszip";
import { saveAs } from "file-saver";
import { floatDiv } from "./common";

const xlsxCellSerial = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CI",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DI",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
  "EA",
  "EB",
  "EC",
  "ED",
  "EE",
  "EF",
  "EG",
  "EH",
  "EI",
  "EJ",
  "EK",
  "EL",
  "EM",
  "EN",
  "EO",
  "EP",
  "EQ",
  "ER",
  "ES",
  "ET",
  "EU",
  "EV",
  "EW",
  "EX",
  "EY",
  "EZ",
];

const createXlsxImgColumn = ({
  workbook,
  ws,
  position = {},
  img = "",
  ext = "",
  style = {},
}) => {
  const imageId = workbook.addImage({
    base64: img,
    extension: ext,
  });

  ws.addImage(imageId, {
    tl: { col: position.x, row: position.y },
    ext: { width: style.width, height: style.height },
  });
};

const createXlsxColumn = ({ ws, column = null, value = "", styles = {} }) => {
  if (column === null) return;

  let attribute = { value, ...styles };
  Object.entries(attribute).forEach(([key, val]) => {
    ws.getCell(column)[key] = val;
  });
};

const createXlsxCellStyle = ({
  font_sz = 12,
  font_color = "000000",
  font_bold = false,
  font_underline = false,
  wrapText = true,
  align_h = "left",
  fill_color = "ffffff",
  border_color = "000000",
  other = {},
} = {}) => {
  return {
    font: {
      size: font_sz,
      color: { argb: font_color },
      bold: font_bold,
      underline: font_underline,
    },
    alignment: {
      horizontal: align_h,
      vertical: "middle",
      wrapText: wrapText,
    },
    border: {
      top: { style: "thin", color: { argb: border_color } },
      bottom: { style: "thin", color: { argb: border_color } },
      left: { style: "thin", color: { argb: border_color } },
      right: { style: "thin", color: { argb: border_color } },
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: {
        argb: fill_color,
      },
    },
    ...other,
  };
};

// 設定欄位寬度
const createColumnWidth = ({ ws, columns = [] } = {}) => {
  columns.forEach((item) => {
    ws.getColumn(item.column).width = item.width;
  });
};

// 設定欄位高度
const createColumnHeight = ({ ws, columns = [] } = {}) => {
  columns.forEach((item) => {
    ws.getRow(item.column).height = item.height;
  });
};

// 設定合併欄位
const createColumnMerge = ({ ws, columns = [] } = {}) => {
  columns.forEach((item) => {
    ws.mergeCells(item.column);
  });
};

const createXlsxSingleTb = ({
  isNewSheet = true,
  isTitle = true,
  titleOptions = {
    label: "",
    position: { x: 0, y: 1 },
    isMerge: false,
    mergeOptions: { start: [0, 1], end: [0, 1] },
  },
  styles = {
    title: {},
    head: {},
    body: {},
  },
  totalOptions = {
    isSum: false,
  },
  workbook,
  worksheet,
  tbHeadColumns,
  tbData,
  createImg,
  defMerges = [],
}) => {
  const ws = isNewSheet ? workbook.addWorksheet(titleOptions.label) : worksheet;
  let titleStyles = {
      font_sz: 16,
      font_color: "000000",
      font_bold: true,
      align_h: "left",
      wrapText: false,
      border_color: "d9d9d9",
      ...styles.title,
    },
    headStyles = {
      font_color: "000000",
      font_bold: true,
      align_h: "left",
      fill_color: "ececec",
      ...styles.head,
    },
    bodyStyles = {
      font_color: "000000",
      align_h: "left",
      ...styles.body,
    },
    merges = [];

  if (isTitle) {
    createXlsxColumn({
      ws,
      column: `${xlsxCellSerial[titleOptions.position.x]}${
        titleOptions.position.y
      }`,
      value: titleOptions.label,
      styles: createXlsxCellStyle({
        ...titleStyles,
      }),
    });

    if (titleOptions.isMerge)
      merges.push({
        column: `${xlsxCellSerial[titleOptions.mergeOptions.start.x]}${
          titleOptions.mergeOptions.start.y
        }:${xlsxCellSerial[titleOptions.mergeOptions.end.x]}${
          titleOptions.mergeOptions.end.y
        }`,
      });
  }

  if (createImg) createImg({ ws });

  let ws_detail = createXlsxDetail({
    ws,
    totalOptions,
    tbHeadColumns,
    tbData,
    position: { x: titleOptions.position.x, y: titleOptions.position.y + 1 },
    headStyles,
    bodyStyles,
  });
  merges = [...merges, ...ws_detail.merges];

  createColumnWidth({
    ws,
    columns: tbHeadColumns.map((column, cIdx) => ({
      column: xlsxCellSerial[titleOptions.position.x + cIdx],
      width: column.exportOptions?.width ?? 10,
    })),
  });

  createColumnMerge({
    ws,
    columns: [...merges, ...defMerges],
  });
};

const createXlsxMultiTb = ({
  isNewSheet = true,
  isTitle = true,
  titleOptions = {
    label: "",
    position: { x: 0, y: 1 },
    isMerge: false,
    mergeOptions: { start: [0, 1], end: [0, 1] },
  },
  isSubTitle = false,
  subTitleOptions = {
    labelKey: "",
  },
  childKey = "data",
  styles = {
    title: {},
    subTitle: {},
    head: {},
    body: {},
  },
  totalOptions = {
    isSum: false,
  },
  workbook,
  worksheet,
  tbHeadColumns,
  tbData,
  defMerges = [],
}) => {
  const ws = isNewSheet ? workbook.addWorksheet(titleOptions.label) : worksheet;
  let titleStyles = {
      font_sz: 16,
      font_color: "000000",
      font_bold: true,
      align_h: "left",
      wrapText: false,
      border_color: "d9d9d9",
      ...styles.title,
    },
    subtitleStyles = {
      font_sz: 14,
      font_color: "3b8afd",
      font_bold: true,
      align_h: "left",
      wrapText: false,
      border_color: "d9d9d9",
      ...styles.subtitle,
    },
    headStyles = {
      font_color: "000000",
      font_bold: true,
      align_h: "left",
      fill_color: "ececec",
      ...styles.head,
    },
    bodyStyles = {
      font_color: "000000",
      align_h: "left",
      ...styles.body,
    },
    merges = [];

  if (isTitle) {
    createXlsxColumn({
      ws,
      column: `${xlsxCellSerial[titleOptions.position.x]}${
        titleOptions.position.y
      }`,
      value: titleOptions.label,
      styles: createXlsxCellStyle({
        ...titleStyles,
      }),
    });

    if (titleOptions.isMerge)
      merges.push({
        column: `${xlsxCellSerial[titleOptions.mergeOptions.start.x]}${
          titleOptions.mergeOptions.start.y
        }:${xlsxCellSerial[titleOptions.mergeOptions.end.x]}${
          titleOptions.mergeOptions.end.y
        }`,
      });
  }

  let rowIdx = titleOptions.position.y + 1;
  tbData.forEach((item) => {
    if (isSubTitle) {
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[titleOptions.position.x]}${rowIdx}`,
        value: item[subTitleOptions.labelKey],
        styles: createXlsxCellStyle({
          ...subtitleStyles,
        }),
      });
      rowIdx++;
    }

    let ws_detail = createXlsxDetail({
      ws,
      totalOptions,
      tbHeadColumns,
      tbData: item[childKey],
      position: { x: titleOptions.position.x, y: rowIdx },
      headStyles,
      bodyStyles,
    });
    merges = [...merges, ...ws_detail.merges];

    rowIdx += item[childKey].length + 2 + (totalOptions.isSum ? 1 : 0);
  });

  createColumnWidth({
    ws,
    columns: tbHeadColumns.map((column, cIdx) => ({
      column: xlsxCellSerial[titleOptions.position.x + cIdx],
      width: column.exportOptions?.width ?? 10,
    })),
  });

  createColumnMerge({
    ws,
    columns: [...merges, ...defMerges],
  });
};

const createXlsxDetail = ({
  ws,
  totalOptions,
  tbHeadColumns,
  tbData,
  position,
  headStyles,
  bodyStyles,
}) => {
  let merges = [],
    rowIdx = position.y;
  tbHeadColumns.forEach((column, cIdx) => {
    const {
      headColStyles = () => {
        return {};
      },
      align_h = "left",
    } = column.exportOptions;

    createXlsxColumn({
      ws,
      column: `${xlsxCellSerial[position.x + cIdx]}${rowIdx}`,
      value: column.header,
      styles: createXlsxCellStyle({
        ...headStyles,
        align_h,
        ...headColStyles(),
      }),
    });
  });

  tbData.forEach((item, index) => {
    rowIdx++;
    tbHeadColumns.forEach((column, cIdx) => {
      let {
        formatVal = null,
        bodyColStyles = () => {
          return {};
        },
        align_h = "LEFT",
        isPercent,
        numFmt = "#,##0",
      } = column.exportOptions;

      let value = formatVal
        ? formatVal({
            allData: item,
            data: item[column.key],
            rowIndex: index,
          })
        : item[column.key];
      if (
        !isNaN(Number(value)) &&
        value !== "" &&
        value !== null &&
        !column.isDate &&
        !column.isString
      )
        value = Number(value);
      if (column.isPercent) value = floatDiv(value ?? 0, 100);
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[position.x + cIdx]}${rowIdx}`,
        value,
        styles: createXlsxCellStyle({
          ...bodyStyles,
          align_h,
          ...bodyColStyles({
            allData: item,
            data: item[column.key],
            field: column.key,
            rowIndex: index,
          }),
        }),
      });

      if (
        typeof value === "number" &&
        value !== "" &&
        value !== null &&
        !column.isDate &&
        !column.isString
      ) {
        if (column.decimalShowRaw) {
          if (String(value).indexOf(".") !== -1) {
            numFmt = "#,##0.#";
          } else {
            numFmt = "#,##0";
          }
        } else if (column.decimalCount) {
          numFmt += ".";
          for (let i = 0; i < column.decimalCount; i++) numFmt += "0";
        }

        if (column.isPercent) numFmt += "%";
        ws.getCell(`${xlsxCellSerial[position.x + cIdx]}${rowIdx}`).numFmt =
          numFmt;
      }

      if (item.isRowSpan && item.rowSpanColumns[column.key]) {
        merges.push({
          column: `${xlsxCellSerial[position.x + cIdx]}${rowIdx}:${
            xlsxCellSerial[position.x + cIdx]
          }${rowIdx + item.rowSpanColumns[column.key] - 1}`,
        });
      }
    });
  });

  if (totalOptions.isSum) {
    rowIdx++;
    let totalData = totalOptions.format({ data: tbData });

    tbHeadColumns.forEach((column, cIdx) => {
      let { align_h, numFmt = "#,##0" } = column.exportOptions;

      let value = totalData[column.key] ?? "";
      if (column.isPercent && value !== "") value = floatDiv(value, 100);
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[position.x + cIdx]}${rowIdx}`,
        value,
        styles: createXlsxCellStyle({
          ...bodyStyles,
          align_h,
          font_bold: true,
          fill_color: "ececec",
        }),
      });

      if (typeof value === "number") {
        if (column.decimalShowRaw) {
          if (String(value).indexOf(".") !== -1) {
            numFmt = "#,##0.#";
          } else {
            numFmt = "#,##0";
          }
        } else if (column.decimalCount) {
          numFmt += ".";
          for (let i = 0; i < column.decimalCount; i++) numFmt += "0";
        }
        if (column.isPercent) numFmt += "%";
        ws.getCell(`${xlsxCellSerial[position.x + cIdx]}${rowIdx}`).numFmt =
          numFmt;
      }
    });
  }

  return {
    merges,
  };
};

const dosnloadExcel = async ({
  workbook,
  workbookName,
  finishAction = () => {},
}) => {
  const mainBuffer = await workbook.xlsx.writeBuffer();
  const mainFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const mainBlob = new Blob([mainBuffer], { type: mainFileType });
  saveAs(mainBlob, `${workbookName}.xlsx`);
  finishAction();
};

const downloadZip = async ({
  filename = "template",
  fileBlob = [],
  finishAction = () => {},
}) => {
  let zip = new JSZip();

  // 製作檔案
  fileBlob.forEach((item) => {
    zip.file(item.filename, item.blob);
  });

  // 把打包內容非同步轉成blob二進位制格式
  zip
    .generateAsync({ type: "blob" }, function updateCallback(metadata) {
      if (metadata.percent == 100) {
        // ServiceCom.switchLoading(false);
      }
    })
    .then(function (content) {
      // content就是blob資料，這裡以example.zip名稱下載
      // 使用了FileSaver.js
      saveAs(content, `${filename}.zip`);
      finishAction();
    });
};

const parseSheetName = (name) => {
  let excludeChar = ["*", "?", ":", "\\", "/", "[", "]"];
  excludeChar.forEach((item) => (name = name.replaceAll(item, "")));
  return name;
};

const formatNumberFormula = (val) => {
  return String(val).indexOf(".") !== -1 ? "#,##0.#" : "#,##0";
};

export {
  xlsxCellSerial,
  createXlsxImgColumn,
  createXlsxColumn,
  createXlsxCellStyle,
  createColumnWidth,
  createColumnHeight,
  createColumnMerge,
  createXlsxSingleTb,
  createXlsxMultiTb,
  dosnloadExcel,
  downloadZip,
  parseSheetName,
  formatNumberFormula,
};
